/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    settings: {
        menu: {
            index: 'Expansion title',
            create: 'New',
            list: 'List MODULE NAME'
        },
        table_titles: {
            id: 'ID',
            title: 'Title',
            option: 'Option',
            setting: 'Edit / Delete',
        },
        edit: 'Edit ModuleName'
    }
}
